/**
* Created by lobin on 2020/6/17.
*/
<template>
  <div class="company-search">
    <a-select
      v-if="mode === 'multiple'"
      mode="multiple"
      label-in-value
      :value="selectItems"
      placeholder="选择关联公司"
      style="width: 100%"
      :filter-option="false"
      :not-found-content="fetching ? undefined : null"
      @search="getData"
      @change="handleChange"
    >
      <a-spin v-if="fetching" slot="notFoundContent" size="small" />
      <a-select-option v-for="d in dataSource" :key="d.value">
        {{ d.text }}
      </a-select-option>
    </a-select>
    <a-auto-complete
        v-else
        v-model="val"
        :data-source="dataSource"
        style="width: 100%"
        :placeholder="placeholder"
        @search="onSearch"
        @change="onChange"
        allowClear
    />
  </div>
</template>

<script type="text/babel">
import { companySearch } from '@/api/company';

export default {
  props: ['placeholder', 'value', 'mode'],
  data() {
    return {
      dataSource: [],
      fetching: false,
    };
  },
  created() {
    this.getData('', 100);
  },
  computed: {
    val: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    selectItems: {
      get() {
        return this.value;
      },
    },
  },
  methods: {
    async onSearch(keyword) {
      this.getData(keyword, 5);
    },
    async getData(keyword, limit) {
      const { data } = await companySearch(keyword, limit);
      this.dataSource = data.map(({ _id, name }) => ({ value: _id, text: name }));
    },
    onChange() {
      // if (value) {
      //   this.$emit('input', value);
      // } else {
      //   this.$emit('input', '');
      // }
    },
    handleChange(selectedItems) {
      this.$emit('input', selectedItems);
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less">

</style>
